<script>
import axios from '@/utils/axios';
import { leadImportConfigByPlatform } from '@/utils/admin';

export default {
  inject: ['setLoading'],
  data() {
    return {
      errors: {},
      title: "CRM",
      text: "CRM", 
      text1: "Import from TradeIndia",
      from_date: '',
      to_date: '',
      platform: 'TradeIndia',
      alert_type: '',
      alert_message: '',
      import_configs: []
    }
  },

  mounted() {
   this.importConfig(); 
  },

  methods: {
   
   async importConfig() {
    this.setLoading(true);
    try{
     const response = await leadImportConfigByPlatform(this.platform);
     this.import_configs = response.data.data;
    }catch(error){
     this.$swalToast(error.message, 'error');
    }finally{
     this.setLoading(false);
    }
   },

   async syncLeads(){
    this.setLoading(true);
    try{
     const payload = {
      from_date: this.from_date,
      to_date:   this.to_date
     };
     const query_string = new URLSearchParams(payload).toString();
     const response = await axios.get(`/leads/import/tradeindia?${query_string}`);
     const message = `${response.data.data.message} [Fetched : ${response.data.data.total_fetched} and Saved : ${response.data.data.saved_count}]`;
     this.alert_type = "alert-success";
     this.alert_message = message;
    }catch(error){
     if(error.type === 'validation'){
      this.errors = error.errors;
     }else{ 
      this.alert_type = "alert-danger";
      this.alert_message = error.message;
     }
    }finally{
     this.setLoading(false); 
    } 
   } 

  }
};
</script>

<style scoped>
.bg-success-light {
  background-color: #d4edda !important;
}

.bg-danger-light {
  background-color: #f8d7da !important;
}

.form-control:focus {
  border-color: #7367f0;
  box-shadow: 0 0 0 0.25rem rgba(115,103,240,0.2);
  transform: translateY(-1px);
}

</style>

<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  
  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content">
      <!-- Breadcrumb -->
      <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div class="">
          <router-link :to="{name: 'leads-list'}" class="btn btn-primary btn-sm">
            <i class="ti ti-chevrons-left"></i> Leads
          </router-link>
        </div>
      </div>
      <!-- /Breadcrumb -->

    <div class="card" style="background-color:#7367f01f;">
     <div class="card-body">
      <div class="indiamart-card">
        <h5><strong>Import your Clients to Algo CRM received in TradeIndia and start engaging with them today.</strong></h5>
        <div class="pt-2 text-primary mt-2 mb-3">
         <strong class="d-md-flex gap-1 flex_w900">
          <span class="bagemb_5 me-2"> Types of leads received in the response : </span>
          <span class="d-md-flex gap-1 bagemb_5">
           <span class="badge bg-primary rounded-pill me-2">Direct Enquiries</span> 
           <span class="badge bg-primary rounded-pill me-2">Buy-Leads</span>
           <span class="badge bg-primary rounded-pill me-2">PNS Calls</span>
           <span class="badge bg-primary rounded-pill me-2">Catalog-view Leads</span>
           <span class="badge bg-primary rounded-pill me-2">WhatsApp Enquiries</span>
          </span>
         </strong>
        </div>
        <!-- <h5 class="mt-1 text-danger"><strong>** Understanding What’s Not Included in the Output:</strong></h5>
         <h6><strong>1. Call Attempts – These are received on the TradeIndia Lead Manager when the user clicks on the call option, but the call did not pass through</strong></h6>
         <h6><strong>2. Catalog Views of already connected Buyers in the past.</strong></h6>
         <h6><strong>3. All Replies (text messages) and Call backs by either side</strong></h6> -->
       </div>
      </div>
     </div>

    <div :class="['alert', 'alert-dismissible', 'fade', 'show', alert_type]" v-if="alert_message">
     <button type="button" class="btn-close" data-bs-dismiss="alert"></button>
     <strong>{{ alert_message }}</strong>
    </div> 

    <div class="card" style="background-color:#7367f01f;">
    <div class="card-body p-5">
     <div class="text-center mb-4">
      <h5 class="fw-bold text-dark mb-1">Sync TradeIndia Leads</h5>
      <small>Last Sync At: <span>{{ $formatDate(import_configs?.last_sync_at, 'DD MMM, YYYY @ hh:mm A') }}</span></small>
      <p class="text-muted mb-0">Select date range to import client enquiries</p>
     </div>
    <form @submit.prevent="syncLeads">
    <div class="row g-4 justify-content-center">
     <div class="col-lg-8">
     <div class="row g-3 align-items-end">
      <div class="col-md-6">
       <label class="form-label fw-semibold text-dark mb-2">From Date</label>
       <div class="position-relative">
        <input type="date" class="form-control form-control-lg rounded-pill ps-5 pe-4 py-3 shadow-sm" v-model="from_date" id="start_date">
        <i class="fas fa-calendar-alt position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
        </div>
        <div class="text-danger small" v-if="errors.from_date">{{ errors.from_date[0] }}</div>
       </div>
          
        <div class="col-md-6">
         <label class="form-label fw-semibold text-dark mb-2">To Date</label>
         <div class="position-relative">
          <input type="date" class="form-control form-control-lg rounded-pill ps-5 pe-4 py-3 shadow-sm" v-model="to_date" id="end_date">
          <i class="fas fa-calendar-alt position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
         </div>
         <div class="text-danger small" v-if="errors.to_date">{{ errors.to_date[0] }}</div>
        </div>
          
        <div class="col-12 text-center pt-2">
         <button type="submit" class="btn btn-lg btn-primary w-100 w-md-50 mx-auto px-5 py-3 rounded-pill shadow-lg fs-24" id="import_btn"> <i class="fas fa-cloud-download-alt me-2"></i>Sync Leads Now</button>
        </div>
        </div>
        </div>
       </div>
       </form>
      </div>
     </div>

    </div>

    <app-footer></app-footer>
  </div>
  <!-- /Page Wrapper -->
</template>